import { render, staticRenderFns } from "./SidebarSection.vue?vue&type=template&id=42f842f4&scoped=true&"
import script from "./SidebarSection.vue?vue&type=script&lang=js&"
export * from "./SidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSection.vue?vue&type=style&index=0&id=42f842f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f842f4",
  null
  
)

export default component.exports